import React from "react";

const Loading = () => {
  return <div className="traditional-loading" />;
};

export default Loading;
